// extracted by mini-css-extract-plugin
export default {"shortz_container":"Shortz_shortz_container__Uxi4i","shortz_player":"Shortz_shortz_player__YISsW","shortz":"Shortz_shortz__6-l4Z","shortz_loading":"Shortz_shortz_loading__p9gO1"};